import React from 'react'
import { hydrateRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from "react-router-dom";
import store from "./store/store";
import { Provider } from "react-redux";
import { HelmetProvider } from 'react-helmet-async';

const initialData = window.__INITIAL_DATA__ || {};
const initialSeo = window.__INITIAL_SEO__ || {};
const globalSchema = window.__GLOBAL_SCHEMA__ || {};
const initialFaq = window.__INITIAL_FAQ__ || null;

hydrateRoot(
  document.getElementById("root"),
  <Provider store={store}>
    <BrowserRouter>
      <HelmetProvider>
        <App initialData={initialData} initialSeo={initialSeo} globalSchema={globalSchema} initialFaq={initialFaq} />
      </HelmetProvider>
    </BrowserRouter>
  </Provider>
);

reportWebVitals();
